import { type FC, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Headline, TabNavigation } from "@fronterahealth/frontera-ui-components";

import { ImportTemplateDialog } from "@components/Templates/ImportTemplateDialog";
import { TemplatesTable } from "@components/Templates/TemplatesTable";

enum TemplatesTab {
  Active = "Active",
  Archived = "Archived",
}

export const Templates: FC = () => {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState<TemplatesTab>(TemplatesTab.Active);
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);

  return (
    <div className="flex flex-col min-h-full">
      <div className="flex items-end justify-between px-16 pb-4 pt-8">
        <Headline size="medium">Templates</Headline>
        <div className="flex gap-2">
          <Button
            text="Generate Template"
            appearance="secondary"
            className="rounded-sm"
            onClick={() => void navigate("/templates/generate")}
          />
          <Button
            text="Import Template"
            appearance="primary"
            className="rounded-sm"
            onClick={() => setIsImportDialogOpen(true)}
          />
        </div>
      </div>
      <div className="px-16">
        <TabNavigation
          tabs={[TemplatesTab.Active, TemplatesTab.Archived].map((tabName) => ({
            name: tabName,
            type: "component" as const,
            current: currentTab === tabName,
            Component: (
              <Button
                text={tabName}
                appearance="text"
                className={`hover:text-primary ${currentTab === tabName ? "text-limestone-900" : "text-text-secondary"}`}
                onClick={() => setCurrentTab(tabName)}
              />
            ),
          }))}
        />
      </div>

      <div className="px-16 w-full">
        <TemplatesTable key={currentTab} statusFilter={currentTab === TemplatesTab.Archived ? "Archived" : undefined} />
      </div>

      <ImportTemplateDialog isDialogOpen={isImportDialogOpen} setDialogOpen={setIsImportDialogOpen} />
    </div>
  );
};
